import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    id: 1,
    title: '2024年度热播大剧',
    subtitle: '《长安十二时辰》全网热播，精彩不容错过',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20warm%20golden%20lighting%2C%20traditional%20costumes%2C%20cinematic%20composition%2C%20dramatic%20atmosphere%2C%20film%20grain%20texture%2C%20rich%20dark%20tones%2C%20professional%20movie%20poster%20style%2C%20artistic%20rendering%20with%20deep%20shadows%20and%20warm%20highlights&width=1920&height=900&seq=hero-1&orientation=landscape',
    link: '/category/tv',
    badge: '热播中',
  },
  {
    id: 2,
    title: '高分电影精选',
    subtitle: '豆瓣8.5分以上好片，品质观影首选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20amber%20and%20gold%20tones%2C%20film%20reel%20elements%2C%20dramatic%20lighting%2C%20artistic%20movie%20poster%20aesthetic%2C%20dark%20cinematic%20background%20with%20soft%20glow%2C%20vintage%20film%20texture%2C%20professional%20cinema%20atmosphere&width=1920&height=900&seq=hero-2&orientation=landscape',
    link: '/category/movie',
    badge: '高分推荐',
  },
  {
    id: 3,
    title: '热门综艺集结',
    subtitle: '欢笑与感动并存，精彩综艺尽在糖豆视频',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20warm%20lighting%2C%20entertainment%20atmosphere%2C%20modern%20studio%20setting%2C%20dynamic%20composition%2C%20golden%20and%20coral%20accent%20lights%2C%20professional%20broadcast%20style%2C%20lively%20and%20energetic%20mood&width=1920&height=900&seq=hero-3&orientation=landscape',
    link: '/category/variety',
    badge: '每周更新',
  },
];

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goToSlide = useCallback(
    (index: number) => {
      if (isTransitioning || index === currentSlide) return;
      setIsTransitioning(true);
      setCurrentSlide(index);
      setTimeout(() => setIsTransitioning(false), 600);
    },
    [currentSlide, isTransitioning]
  );

  useEffect(() => {
    const timer = setInterval(() => {
      goToSlide((currentSlide + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide, goToSlide]);

  const slide = slides[currentSlide];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700 ease-in-out"
        style={{ backgroundImage: `url(${slide.imageUrl})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-4 md:px-6 flex flex-col justify-center">
        <div key={slide.id} className="animate-[fadeInUp_0.6s_ease-out]">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium mb-4">
            {slide.badge}
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-background-50 mb-3 font-heading">
            {slide.title}
          </h2>
          <p className="text-base md:text-lg text-background-200 max-w-xl mb-6">
            {slide.subtitle}
          </p>
          <Link
            to={slide.link}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all no-underline whitespace-nowrap"
          >
            立即观看
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2.5 h-2.5 rounded-full border-none cursor-pointer transition-all duration-300 ${
                index === currentSlide
                  ? 'bg-primary-500 w-7'
                  : 'bg-background-50/50 hover:bg-background-50/80'
              }`}
              aria-label={`切换到第 ${index + 1} 张`}
            />
          ))}
        </div>
      </div>

      <button
        onClick={() =>
          goToSlide((currentSlide - 1 + slides.length) % slides.length)
        }
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/40 flex items-center justify-center cursor-pointer border-none transition-all z-10 backdrop-blur-sm"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg text-background-50"></i>
      </button>
      <button
        onClick={() => goToSlide((currentSlide + 1) % slides.length)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/40 flex items-center justify-center cursor-pointer border-none transition-all z-10 backdrop-blur-sm"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg text-background-50"></i>
      </button>
    </section>
  );
}